export default defineAppConfig({
  ui: {
    primary: 'cardinal',
    strategy: 'override',
    notification: {
      // Show toasts at the bottom right of the screen
      position: 'bottom-0 top-auto',
      // // Show toasts at the top middle of the screen
      // position: 'top-0 left-1/2 -translate-x-1/2 bottom-auto'
    },
    button: {
      base: 'sixtyfour-btn focus:outline-none focus-visible:outline-0 disabled:cursor-not-allowed disabled:opacity-75 flex-shrink-0',
    },
    card: {
      background: 'dark:bg-neutral-900',
    },
    tabs: {
      container: '!-mt-0',
      list: {
        height: 'h-12',
        background: '!bg-transparent',
        // width: 'lg:!w-auto',
        marker: {
          background: '!bg-neutral-950 dark:!bg-white z-[1]',
        },
        tab: {
          // base: `relative inline-flex items-center justify-center ui-focus-visible:outline-0 ui-focus-visible:ring-2 ui-focus-visible:ring-primary-500 dark:ui-focus-visible:ring-primary-400 ui-not-focus-visible:outline-none focus:outline-none disabled:cursor-not-allowed disabled:opacity-75 transition-colors duration-200 ease-out`,
          base: `!w-auto border-b-2 border-b-transparent z-[2] outline-neutral-50 dark:outline-neutral-800`,
          active: '!border-b-cardinal dark:borer-b-cardinal-400 !text-white dark:!text-neutral-950',
          height: 'h-10',
          rounded: 'rounded-none',
        },
      },
    },
    table: {
      wrapper: 'relative custom-scrollbar horizontal overflow-x-auto',
      tr: {
        base: `even:bg-neutral-100 dark:bg-neutral-900 dark:even:bg-neutral-950`,
      },
    },
  },
});
